import { cookiesExpiresDate } from './../../utilities/index';
import * as cookie from 'react-cookies';

export const CART_COOKIE_ID = 'cart_id';

export function saveCartCookie(cartId: string) {
  cookie.save(CART_COOKIE_ID, cartId, {
    path: '/',
    expires: cookiesExpiresDate(),
  });
}

export function loadCartCookie(cartCookieReq?: string): string | undefined {
  if (cartCookieReq) {
    return cartCookieReq;
  }
  return cookie.load(CART_COOKIE_ID);
}

export function removeCartCookie(): void {
  cookie.remove(CART_COOKIE_ID, { path: '/' });
}
